import { createContext, useContext } from 'react';
export const LoggerContext = createContext(undefined);
/**
 * Custom hook to get the logger instance.
 *
 * @throws An error if the hook is used outside of a LoggerContext.
 * @returns The logger instance
 */
export const useLogger = () => {
    const logger = useContext(LoggerContext);
    if (!logger) {
        throw new Error('useLogger must be used within a LoggerContext');
    }
    return logger;
};
